import React from 'react'
import AccountRecipeComponent from 'components/AccountRecipesComponent'

function AccountRecipes() {
  return <AccountRecipeComponent />
}

export default AccountRecipes
